import { AUTH_HEADERS } from '../constants/headers';
import { RequestInput } from '../types';
import { getAccessToken, isAccessTokenAuth0 } from './cookies';
import { getUrlString } from './url';

function getBearerToken(authHeader: string | null): string | null {
    if (!authHeader) return null;

    const match = /^Bearer (.+)$/i.exec(authHeader);
    return match ? match[1] : null;
}

export const updateInitWithValidAuthHeader = ({
    url,
    init,
}: {
    url: RequestInput;
    init?: RequestInit;
}): RequestInit | undefined => {
    // Match /logout or /auth as exact path segments (not substrings like /authenticated)
    // These should be followed by /, end of string, ?, or #
    const urlString = getUrlString(url);
    const logoutOrAuthRegex = /\/(logout|auth)(\/|$|\?|#)/;
    const isLogoutOrAuthUrl = logoutOrAuthRegex.test(urlString);

    // Only send marker when the token we actually send is an Auth0 token.
    const sendAuth0Header = isAccessTokenAuth0();
    const initHeaders = init?.headers;

    if (!initHeaders && !sendAuth0Header) {
        return init;
    }

    if (!initHeaders && sendAuth0Header) {
        const headers = new Headers();
        headers.set(AUTH_HEADERS.X_PETM_AUTH0_ENABLED, 'true');
        return {
            ...init,
            headers,
        };
    }

    const headers = new Headers(initHeaders ?? undefined);
    const authHeader = headers.get('Authorization');
    const requestAuthToken = getBearerToken(authHeader);
    const existingMarker = headers.get(AUTH_HEADERS.X_PETM_AUTH0_ENABLED);
    const shouldAddAuth0Marker = sendAuth0Header && existingMarker !== 'true';

    if (shouldAddAuth0Marker) {
        headers.set(AUTH_HEADERS.X_PETM_AUTH0_ENABLED, 'true');
    }
    if (isLogoutOrAuthUrl) {
        if (shouldAddAuth0Marker) {
            return {
                ...init,
                headers,
            };
        }
        return init;
    }

    const accessToken = getAccessToken();
    if (requestAuthToken && accessToken && accessToken !== requestAuthToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
        return {
            ...init,
            headers,
        };
    }
    if (shouldAddAuth0Marker) {
        return {
            ...init,
            headers,
        };
    }
    return init;
};
